<template>
  <div class="vipLink w-main">
    <div class="vip-list" v-for="(item, index) in vipData" :key="index">
      <div class="item-box">
        <a :href="`${item.url}`" target="_blank">
          <el-image :src="item.img" fit="fill" :title="item.name"></el-image>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import item1 from "@/assets/img/home/item1.jpg";
import item2 from "@/assets/img/home/item2.jpg";
import item3 from "@/assets/img/home/item3.jpg";
import item4 from "@/assets/img/home/item4.jpg";
import item5 from "@/assets/img/home/item5.jpg";
import item6 from "@/assets/img/home/item6.jpg";
import item7 from "@/assets/img/home/item7.jpg";
import item8 from "@/assets/img/home/item8.jpg";
import item9 from "@/assets/img/home/item9.jpg";
import item10 from "@/assets/img/home/item10.jpg";
import item11 from "@/assets/img/home/item11.jpg";
import item12 from "@/assets/img/home/item12.jpg";
import item13 from "@/assets/img/home/item13.jpg";
import item14 from "@/assets/img/home/item14.jpg";
import item15 from "@/assets/img/home/item15.jpg";
import item16 from "@/assets/img/home/item16.jpg";
import item17 from "@/assets/img/home/item17.jpg";
import item18 from "@/assets/img/home/item18.jpg";
import item19 from "@/assets/img/home/item19.jpg";
import item20 from "@/assets/img/home/item20.jpg";
import item21 from "@/assets/img/home/item21.jpg";
import { getMemberList } from "@/api/api.js";

export default {
  name: "pcHomeVipLink",
  data() {
    return {
      // img: {
      //   item:
      // },
      vipData: [
        {
          url: "http://www.coscoshipping.com/",
          name: "中远海运集团有限公司",
          img: item1
        },
        {
          url: "https://www.shmtu.edu.cn/",
          name: "上海海事大学",
          img: item2
        },
        {
          url: "http://www.chipolbrok.com.cn/chipolbrok/",
          name: "中波轮船股份公司",
          img: item3
        },
        {
          url: "https://www.jjshipping.cn/",
          name: "上海锦江航运（集团）有限公司",
          img: item4
        },
        {
          url: "https://www.cccc-sdc.com/",
          name: "中交上海航道局有限公司",
          img: item5
        },
        {
          url: "",
          name: "上海振华海洋工程集团服务有限公司",
          img: item6
        },
        {
          url: "https://www.sh-pilots.com.cn/",
          name: "上海港引航站",
          img: item7
        },
        {
          url: "http://www.northsea.com.cn/",
          name: "上海北海船务股份有限公司",
          img: item8
        },
        {
          url: "http://www.fxcw.com/",
          name: "上海港复兴船务公司",
          img: item9
        },
        {
          url: "http://www.sbss.com/cn",
          name: "中英海底系统有限公司",
          img: item10
        },
        {
          url: "http://www.msshipping.cn/",
          name: "上海民生轮船有限公司",
          img: item11
        },
        {
          url: "https://hyxy.shou.edu.cn/",
          name: "上海海洋大学海洋科学学院",
          img: item12
        },
        {
          url: "http://www.gh-shipping.com/",
          name: "福建国航远洋运输（集团）股份有限公司",
          img: item13
        },
        {
          url: "http://www.pric.org.cn/",
          name: "中国极地研究中心船舶与飞机管理处",
          img: item14
        },
        {
          url: "http://www.shiw.cccc-sdc.com/",
          name: "中交上海航道勘察设计院有限公司",
          img: item15
        },
        {
          url: "http://www.sfgc.com.cn/",
          name: "上海水产集团有限公司",
          img: item16
        },
        {
          url: "http://www.donghai-rescue.cn/",
          name: "交通运输部东海救助局救助船队",
          img: item17
        },
        {
          url: "http://sh.cma.gov.cn/",
          name: "上海中心气象台",
          img: item18
        },
        {
          url: "https://shhsfy.gov.cn/load.html?d=1595995108149",
          name: "上海海事法院",
          img: item19
        },
        {
          url: "https://www.fmiri.ac.cn/",
          name: "中国水产科学研究院渔业机械仪器研究所",
          img: item20
        },
        {
          url: "http://www.dinghengshipping.com/",
          name: "上海鼎衡船务有限公司",
          img: item21
        }
      ]
    };
  },
  mounted() {
    // this.getMemberList();
  },
  methods: {
    getMemberList() {
      getMemberList().then(res => {
        if (res.code === 0) {
          this.vipData = res.data;
        } else {
          this.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    }
  }
};
</script>

<style lang="less">
.vipLink {
  display: flex;
  flex-flow: wrap;
  .vip-list {
    width: 14%;
    margin: 28px 0;
    .item-box {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto;
      width: 100px;
      height: 100px;
      border: 1px solid rgba(210, 210, 210, 1);
      border-radius: 50%;
      .el-image {
        width: 82px;
        height: 82px;
        border-radius: 50%;
        overflow: hidden;
      }
    }
  }
}
</style>
